import React, { lazy, Component } from 'react';
import { ShieldCheck, Video, Maximize, Clock, Printer } from 'lucide-react';
import { Button } from './ui/Button';
export function FlyerA6() {
  const handlePrint = () => {
    window.print();
  };
  // Tracking URL for A6 flyer
  const trackingUrl = 'https://holdmyvan.com.au?utm_source=flyer_a6&utm_medium=qr_code&utm_campaign=reception_handout';
  return <div className="min-h-screen bg-gray-100 p-8 flex flex-col items-center justify-center font-sans" data-id="element-245">
      {/* Print Button - Hidden when printing */}
      <div className="mb-8 print:hidden" data-id="element-246">
        <Button onClick={handlePrint} className="flex items-center gap-2 shadow-lg" data-id="element-247">
          <Printer className="h-5 w-5" data-id="element-248" />
          Print A6 Flyer
        </Button>
        <p className="mt-2 text-sm text-gray-500 text-center" data-id="element-249">
          Best printed in Portrait / A6
        </p>
      </div>

      {/* A6 Flyer Container - 105mm x 148mm */}
      <div className="bg-[#fbf7dd] w-[105mm] h-[148mm] shadow-2xl print:shadow-none print:w-full print:h-full relative overflow-hidden flex flex-col border border-gray-200 print:border-none" data-id="element-250">
        {/* Header */}
        <header className="bg-[#175445] text-[#fbf7dd] p-4 flex flex-col items-center justify-center text-center print:bg-[#175445] print:text-[#fbf7dd] print-color-adjust-exact shrink-0" data-id="element-251">
          <img src="https://cdn.magicpatterns.com/uploads/8iyBWSo8vRExHMrz3iz275/Hold_My_Van_Full_Colour_Logo_1500px_V1.png" alt="Hold My Van" className="h-8 w-8 mb-2" loading="lazy" width="32" height="32" data-id="element-252" />
          <div className="bg-[#FFC107] text-black px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider print:bg-[#FFC107] print:text-black" data-id="element-253">
            Coming Soon to Perth
          </div>
        </header>

        {/* Main Content */}
        <div className="p-4 flex-grow flex flex-col justify-between" data-id="element-254">
          {/* Headline */}
          <div className="text-center mb-3" data-id="element-255">
            <h1 className="text-xl font-bold text-[#175445] leading-tight mb-1" data-id="element-256">
              Secure Caravan & <br data-id="element-257" /> Boat Storage
            </h1>
            <p className="text-sm font-bold text-gray-600" data-id="element-258">
              Close to Perth - Within 35km of CBD
            </p>
          </div>

          {/* Benefits - Compact Grid */}
          <ul className="grid grid-cols-2 gap-2 mb-3 list-disc list-inside" data-id="element-259">
            <li className="flex items-center gap-2" data-id="element-260">
              <Video className="h-4 w-4 text-[#175445] flex-shrink-0" data-id="element-261" />
              <span className="text-xs font-bold text-gray-800" data-id="element-262">
                24/7 Monitoring
              </span>
            </li>
            <li className="flex items-center gap-2" data-id="element-263">
              <ShieldCheck className="h-4 w-4 text-[#175445] flex-shrink-0" data-id="element-264" />
              <span className="text-xs font-bold text-gray-800" data-id="element-265">
                Secure Gated
              </span>
            </li>
            <li className="flex items-center gap-2" data-id="element-266">
              <Maximize className="h-4 w-4 text-[#175445] flex-shrink-0" data-id="element-267" />
              <span className="text-xs font-bold text-gray-800" data-id="element-268">
                9m x 3m Bays
              </span>
            </li>
            <li className="flex items-center gap-2" data-id="element-269">
              <Clock className="h-4 w-4 text-[#175445] flex-shrink-0" data-id="element-270" />
              <span className="text-xs font-bold text-gray-800" data-id="element-271">
                Flexible Terms
              </span>
            </li>
          </ul>

          {/* Pricing Box */}
          <div className="bg-gray-50 border border-[#175445] rounded-lg p-2 text-center mb-3 print:bg-gray-50" data-id="element-272">
            <div className="flex items-baseline justify-center gap-1" data-id="element-273">
              <span className="text-sm font-medium text-gray-500" data-id="element-274">from</span>{' '}
              <span className="text-2xl font-bold text-[#175445]" data-id="element-275">$29</span>
              <span className="text-xs text-gray-500" data-id="element-276">/week</span>
            </div>
            <div className="bg-[#FFC107] text-black text-[10px] font-bold px-2 py-0.5 rounded-full inline-block mt-1" data-id="element-277">
              Early bird pricing available
            </div>
          </div>

          {/* QR Code Section */}
          <div className="flex items-center gap-3 bg-[#175445]/5 p-2 rounded-lg border border-[#175445]/10" data-id="element-278">
            <div className="bg-[#fbf7dd] p-1 border border-gray-200 rounded shrink-0" data-id="element-279">
              <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(trackingUrl)}&color=1A7B7E`} alt="Scan QR" className="w-16 h-16" loading="lazy" width="64" height="64" data-id="element-280" />
            </div>
            <div className="flex-grow" data-id="element-281">
              <p className="font-bold text-[#175445] text-sm leading-tight mb-1" data-id="element-282">
                Scan to Register Interest
              </p>
              <p className="text-xs text-gray-600 mb-1" data-id="element-283">
                Limited spaces available!
              </p>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wide" data-id="element-284">
                holdmyvan.com.au
              </p>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-285">{`
        @media print {
          @page {
            size: A6 portrait;
            margin: 0;
          }
          body {
            background: white;
            padding: 0;
          }
          .print\\:hidden {
            display: none !important;
          }
          .print\\:shadow-none {
            box-shadow: none !important;
          }
          .print\\:w-full {
            width: 100% !important;
          }
          .print\\:h-full {
            height: 100% !important;
          }
          .print\\:border-none {
            border: none !important;
          }
          /* Ensure colors print correctly */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>
    </div>;
}